'use strict';

import React from 'react';
import 'bootstrap/dist/css/bootstrap-reboot.css';
require('./styles/styles.global.css');
import { render } from 'react-dom';
import Root from './components/Root';
import lifeOmicHelpers from './util/lifeOmicHelpers';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import configureApolloClient from './configureApolloClient';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import store from './redux/store';

const apolloClient = configureApolloClient(store);

(window as any).LifeOmic = {
  util: lifeOmicHelpers(store),
  buildManifest: process.env.BUILD_MANIFEST || {},
};

function renderApp() {
  render(
    (<Root store={store} apolloClient={apolloClient} />) as any,
    document.getElementById('root'),
  );
}

renderApp();
